import type { BookingVehicleInfo } from "../../../components/FleetManagement/types/FleetManagement-row.types";
import type { BookableBookingObjectDto } from "../typings/resource-calendar.types";
import { createStubFleetVehicleForResourceBooking } from "./createStubFleetVehicleForResourceBooking";

/** Uses fleet prefetch when present; otherwise a catalog stub so confirm can render. */
export function vehicleInfoFromPrefetchOrStub(
  prefetched: BookingVehicleInfo | null | undefined,
  row: BookableBookingObjectDto
): BookingVehicleInfo {
  return prefetched ?? createStubFleetVehicleForResourceBooking(row);
}
